export const wishlistHeartEmpty = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1003_1611)">
      <path
        d="M20.1602 4.48998C17.5202 2.68998 14.2602 3.52998 12.5002 5.58998C10.7402 3.52998 7.48021 2.67998 4.84021 4.48998C3.44021 5.44998 2.56021 7.06998 2.50021 8.77998C2.36021 12.66 5.80021 15.77 11.0502 20.54L11.1502 20.63C11.9102 21.32 13.0802 21.32 13.8402 20.62L13.9502 20.52C19.2002 15.76 22.6302 12.65 22.5002 8.76998C22.4402 7.06998 21.5602 5.44998 20.1602 4.48998ZM12.6002 19.05L12.5002 19.15L12.4002 19.05C7.64021 14.74 4.50021 11.89 4.50021 8.99998C4.50021 6.99998 6.00021 5.49998 8.00021 5.49998C9.54021 5.49998 11.0402 6.48998 11.5702 7.85998H13.4402C13.9602 6.48998 15.4602 5.49998 17.0002 5.49998C19.0002 5.49998 20.5002 6.99998 20.5002 8.99998C20.5002 11.89 17.3602 14.74 12.6002 19.05Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1003_1611">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const wishlistHeart = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_302_1755)">
      <path
        d="M13.3502 20.13C12.5902 20.82 11.4202 20.82 10.6602 20.12L10.5502 20.02C5.30015 15.27 1.87015 12.16 2.00015 8.27998C2.06015 6.57998 2.93015 4.94998 4.34015 3.98998C6.98015 2.18998 10.2402 3.02998 12.0002 5.08998C13.7602 3.02998 17.0202 2.17998 19.6602 3.98998C21.0702 4.94998 21.9402 6.57998 22.0002 8.27998C22.1402 12.16 18.7002 15.27 13.4502 20.04L13.3502 20.13Z"
        fill="#F3F3F3"
      />
    </g>
    <defs>
      <clipPath id="clip0_302_1755">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
